<template>
<div class="gallery">
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="myData.length"
      class="layout"
    >
      <br>
      <carousel :slides="myData" :interval="30000" controls indicators></carousel>
    </div>
    <div
      v-else
      class="card"
    >
      <p>No new school events at the moment, check back later</p>
      <Spinner />
    </div>
  <manage-gallery v-if="currentUser.state.role==='testAdmin'" :events="myData"></manage-gallery>
</div>
</template>

<script>
import Carousel from '@/components/gallery/Carousel.vue'
import ManageGallery from '@/components/gallery/ManageGallery.vue'
import getPosts from '@/composables/getPosts'
import Spinner from '@/components/Spinner.vue'
import { inject } from '@vue/runtime-core'
export default {
  name: 'Events',
  components: { Carousel, ManageGallery, Spinner },
  setup () {
    const currentUser = inject('currentUser')
    const { myData, error, load } = getPosts()

    load('events')

    return { myData, error, currentUser }
  }
}
</script>

<style></style>
